<template>
  <div class="case-box1">
    <div class="video-box">
      <div class="play" @click="isActive=true"></div>
      <img :src="cardInfo.imgSrc" alt="">
    </div>
    <span>{{ cardInfo.origin }}</span>
    <h1>{{ cardInfo.title }}</h1>
    <!-- modal 层 -->
    <modal @close="isActive=false" :isActive="isActive" v-if="isActive">
      <div slot="content" class="video-wrapper">
        <video :src="cardInfo.videoSrc" autoplay="autoplay" controls="controls" loop="loop" preload="auto"></video>
      </div>
    </modal>
  </div>
</template>

<script>
import modal from '@/components/modal/modal'

export default {
  data () {
    return {
      isActive: false
    }
  },
  props: ['cardInfo'],
  components: {
    modal
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/app.sass';

.case-box1 {
  display: flex;
  flex-direction: column;
  width: 405px;
  padding: 21px; padding-bottom: 33px;
  box-sizing: border-box;
  border: 1px solid $border-color1;
  border-radius: 3px;
  @include tablet {
    width: calc(33.333% - 20px);
  }
  @include mobile {
    margin-bottom: 20px;
    padding-bottom: 26px;
  }
  & .video-box {
    position: relative;
    // height: 205px;
    margin-bottom: 20px;
    @include mobile {
      margin-bottom: 10px;
    }
    & .play {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 49px;
      height: 34px;
      background-image: url('../../assets/img/google-img/play-gray.png');
      background-repeat: no-repeat;
      background-size: 100%;
      background-position: center;
      cursor: pointer;
    }
    & img {
      width: 100%;
      // height: 100%;
    }
  }
  & span {
    line-height: 1;
    color: $font-color2;
    font-size: $fontSize12;
    font-weight: 500;
    margin-bottom: 8px;
  }
  & h1 {
    color: $font-color1;
    font-size: $fontSize20;
    font-weight: 500;
    line-height: 27px;
    @include limit-line-numbers(2);
  }
  &:hover {
    background: $primary2;
    & span,
    & h1 {
      color: #fff;
    }
    & .video-box {
      & .play {
        background-image: url('../../assets/img/google-img/play-red.png');
      }
    }
  }
}

.video-wrapper {
  video {
    width: 100%;
    height: 100%;
  }
}

@include mobile {
  .case-box1 {
    width: 100%;
    & .video-box {
      width: 100%;
    }
  }
}
</style>
